module.exports = __webpack_public_path__ + "static/media/serv_revetement.2fa890df.png";